/**
 * Free tier (Rob, 2026-10-11).
 *
 * WHY THIS EXISTS:
 * BotSpot is testing a free tier: no card, a small monthly AI and backtest
 * allowance, deploying and trading stay paid. The server decides through
 * `freeTier.enabled` on payment status; it is off unless Node turns it on.
 *
 * The free tier has no special UI on purpose (Rob, 2026-10-11): a free user
 * sees the same AI agent page, chips, model picker, usage ring and upgrade
 * offer as everyone else. Never show free users their dollar allowance.
 * This module only parses the server switch for routing and access.
 *
 * INVARIANTS:
 * - `enabled` is true only when the server sent a literal `true`.
 */
import { z } from 'zod';

export type FreeTierStatus = { enabled: boolean };

export const DISABLED_FREE_TIER: FreeTierStatus = Object.freeze({ enabled: false });

const freeTierStatusSchema = z.object({ enabled: z.literal(true) });

/** Raw server value; parsed by the schema below. */
type ServerValue = Parameters<typeof freeTierStatusSchema.safeParse>[0];

export function normalizeFreeTier(raw: ServerValue): FreeTierStatus {
  return freeTierStatusSchema.safeParse(raw).success ? { enabled: true } : DISABLED_FREE_TIER;
}
